import React from "react";
import { Stepper } from '@activehub/common-components-spa'
import "./AccessCodeRegister.scss";
import AccessCode from "./AccessCode";
import ActivationSuccessTemplate from "./ActivationSuccessTemplate";
import { useAction } from './useAction';

const steps = [
  'Access code',
  'Activation complete'
]

export const AccessCodeForm = (props) => {
  const { step, handleNextStep, handleBackStep } = useAction();
  const renderstep = (step) => {
    switch (step) {
      case 1: return <AccessCode onNextStep={handleNextStep} onBackStep={handleBackStep} />;
      case 2: return <ActivationSuccessTemplate />;
      default: return <div>404 - Not Found</div>
    }
  }

  return (
    <div className="ActiveHubStepper ah-mobile-tab-responsive" >
      <Stepper steps={steps} active={step === 2 ? 3 : step} themeClass={"pearsonRoyalBlueV1"} />
      {renderstep(step)}
    </div>
  )
};


